import { ROUTE_AVAILABILITY_GROUPS_DETAILS } from '@/constants/routes';
import IEventType from '@/types/IEventType';
import IResourceGroup from '@/types/IResourceGroup';
import {
    Box,
    Button,
    ButtonGroup,
    Checkbox,
    FormControl,
    FormLabel,
    Grid,
    Heading,
    IconButton,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';
import { FiEdit, FiPlus } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useAddMemberModal } from './add-group.controller';

interface IProps {
	resourceGroups: Array<IResourceGroup>;
	eventType: IEventType;
	isOpen: boolean;
	close: () => void;
}

export default function AddGroupModal(props: IProps) {
	const { form, handleSubmit, handleCreateGroupClick, t } = useAddMemberModal(props);

	return (
		<>
			<Modal isOpen={props.isOpen} onClose={props.close} size="2xl" isCentered>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>
						<Heading size="lg">{t('Add group')}</Heading>
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Box as="form" id="form-add-participant" onSubmit={handleSubmit}>
							<Text>
								{t(
									'Crea normas avanzadas de disponibilidad mediante grupos. Por ejemplo: Necesito dos personas del grupo VENTAS y una persona del grupo MARKETING.'
								)}
							</Text>
							<FormControl id="email" mt={4}>
								<Grid mt={6} mb={2} gridTemplateColumns="1fr auto" alignContent="center">
									<FormLabel>{t('Groups')}</FormLabel>
									<Button size="sm" rightIcon={<FiPlus />} onClick={handleCreateGroupClick}>
										{t('Create group')}
									</Button>
								</Grid>
								{!props.resourceGroups.length ? (
									<Box my={4}>
										<Text>{t('You have not created any groups yet.')}</Text>
									</Box>
								) : null}
								{props.resourceGroups.map((group, index) => {
									return (
										<Grid
											key={group.id}
											p={4}
											gridTemplateColumns="1fr auto"
											alignItems="center"
											borderWidth={1}
											borderColor="gray.200"
											borderRadius="md"
											mb={1}
										>
											<Text>{group.name}</Text>
											<ButtonGroup>
												<IconButton
													aria-label={t('Edit')}
													icon={<FiEdit />}
													variant="ghost"
													size="sm"
													as={Link}
													to={ROUTE_AVAILABILITY_GROUPS_DETAILS.replace(':id', group.id)}
												/>
												<Checkbox
													display="flex"
													justifyContent="flex-start"
													alignItems="center"
													key={group.id}
													{...form.register(`resourceGroups.${index}.isSelected` as const)}
												></Checkbox>
											</ButtonGroup>
										</Grid>
									);
								})}
							</FormControl>
						</Box>
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" mr={3} onClick={props.close}>
							{t('Close')}
						</Button>
						<Button
							form="form-add-participant"
							isDisabled={!form.formState.isValid || !form.watch('resourceGroups').filter((x) => x.isSelected).length}
							isLoading={form.formState.isSubmitting}
							colorScheme="primary"
							type="submit"
						>
							{t('Add groups to the reservation calendar')}
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
